<template>
  <section class='header-instruments no-mobile'>
    <badges/>
    <personal-area/>
    <!-- This commented until we decide which exactly libraries to get-->
<!--    <products-menu/>-->
    <user-info/>
  </section>
</template>

<script>
import Badges from '@/components/badges'
import PersonalArea from '@/components/personal-area'
// import ProductsMenu from '@/components/products-menu'
import UserInfo from '@/components/user-info'
export default {
  name: 'header-instruments',
  components: { UserInfo, PersonalArea, Badges }
}
</script>

<style scoped>

</style>
